

// https://www.dropbox.com/s/<id>/<name>
// https://www.dl.dropboxusercontent.com/s/<id>/<name>



export const parseDropboxLink = (url:string) => {
	if(!isShareLink(url)){
		return url;
	}
	url = url.replace("dropbox.com", "dl.dropboxusercontent.com");
	return url;
};


export const isDropboxLink = (url:string) => {

	return [
		"https://www.dropbox.com/s/",
		"https://dropbox.com/s/",
		"https://www.dl.dropboxusercontent.com/s/",
		"https://dl.dropboxusercontent.com/s/",
	].findIndex(u => url.startsWith(u)) > -1;
};


const isShareLink = (url:string) => {
	return [
		"https://www.dropbox.com/s/",
		"https://dropbox.com/s/",
	].findIndex(u => url.startsWith(u)) > -1;
};